import { Head, Link, useForm } from "@inertiajs/react";
import PlainLayout from "@/layouts/plain-layout";
import { new_session_path, registration_path } from "@/routes";

function roleLabel(role) {
  return role?.replace(/Role$/, "").replace(/([a-z])([A-Z])/g, "$1 $2");
}

function NewRegistration({ user, invitation, errors }) {
  const { data, setData, post, processing } = useForm({
    invitation_token: invitation?.token || "",
    user: {
      email: invitation?.email || user.email || "",
      first_name: user.first_name || "",
      last_name: user.last_name || "",
      password: "",
      password_confirmation: ""
    }
  });

  const submit = (e) => {
    e.preventDefault();
    post(registration_path());
  };

  return (
    <>
      <Head title="Opret konto" />

      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-md-6 col-lg-5">
            <div className="card shadow-sm rounded-4 border-0">
              <div className="card-body p-4">
                <h1 className="h4 text-center fw-semibold mb-4">Kom i gang</h1>
                {invitation && (
                  <div className="alert alert-light border rounded-3 mb-3 text-start">
                    <div className="fw-semibold">Invitation til {invitation.organization_name}</div>
                    <div className="small text-muted mt-1">
                      Rolle: {roleLabel(invitation.role)}. Opret din konto for at acceptere invitationen.
                    </div>
                  </div>
                )}
                {errors?.length > 0 && <div className="alert alert-danger text-center mb-3">{errors.join(", ")}</div>}
                <form className="vstack gap-3" onSubmit={submit}>
                  <div>
                    <label className="form-label">E-mail</label>
                    <input
                      className="form-control"
                      value={data.user.email}
                      onChange={(e) => setData("user", { ...data.user, email: e.target.value })}
                      readOnly={Boolean(invitation)}
                      required
                    />
                  </div>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label className="form-label">Adgangskode</label>
                      <input className="form-control" type="password" value={data.user.password} onChange={(e) => setData("user", { ...data.user, password: e.target.value })} required />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Bekræft adgangskode</label>
                      <input className="form-control" type="password" value={data.user.password_confirmation} onChange={(e) => setData("user", { ...data.user, password_confirmation: e.target.value })} required />
                    </div>
                  </div>
                  <div>
                    <label className="form-label">Fornavn</label>
                    <input className="form-control" value={data.user.first_name} onChange={(e) => setData("user", { ...data.user, first_name: e.target.value })} required />
                  </div>
                  <div>
                    <label className="form-label">Efternavn</label>
                    <input className="form-control" value={data.user.last_name} onChange={(e) => setData("user", { ...data.user, last_name: e.target.value })} required />
                  </div>
                  <button className="btn btn-primary w-100 rounded-3 py-2 fw-semibold" disabled={processing}>Opret konto</button>
                </form>
                <div className="text-center mt-3">
                  <Link href={new_session_path()} className="small text-decoration-none">Tilbage til log ind</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

NewRegistration.layout = (page) => <PlainLayout>{page}</PlainLayout>;

export default NewRegistration;
